import { z } from "zod";

export const atmosphereMemberProfileSchema = z.object({
  specificHealthTags: z.array(z.string()).default([]),
  specificProductTags: z.array(z.string()).default([]),
  specificFamilyTags: z.array(z.string()).default([]),
  specificStoryTags: z.array(z.string()).default([]),
  specificToneTags: z.array(z.string()).default([]),
  forbiddenTopics: z.array(z.string()).default([]),
  personaSummary: z.string().default(""),
  compactProfile: z.string().default(""),
});

export type AtmosphereMemberProfile = z.infer<typeof atmosphereMemberProfileSchema>;

export const EMPTY_ATMOSPHERE_MEMBER_PROFILE: AtmosphereMemberProfile = {
  specificHealthTags: [],
  specificProductTags: [],
  specificFamilyTags: [],
  specificStoryTags: [],
  specificToneTags: [],
  forbiddenTopics: [],
  personaSummary: "",
  compactProfile: "",
};

const SNAKE_TO_CAMEL_PROFILE_KEYS: Record<string, keyof AtmosphereMemberProfile> = {
  specific_health_tags: "specificHealthTags",
  specific_product_tags: "specificProductTags",
  specific_family_tags: "specificFamilyTags",
  specific_story_tags: "specificStoryTags",
  specific_tone_tags: "specificToneTags",
  forbidden_topics: "forbiddenTopics",
  persona_summary: "personaSummary",
  compact_profile: "compactProfile",
};

export function normalizeAtmosphereMemberProfile(
  input?: Partial<AtmosphereMemberProfile> | Record<string, unknown> | null
): AtmosphereMemberProfile {
  if (!input || typeof input !== "object") {
    return atmosphereMemberProfileSchema.parse({});
  }

  const normalized: Record<string, unknown> = { ...(input as Record<string, unknown>) };
  for (const [snakeKey, camelKey] of Object.entries(SNAKE_TO_CAMEL_PROFILE_KEYS)) {
    const source = input as Record<string, unknown>;
    if (snakeKey in source && normalized[camelKey] === undefined) {
      normalized[camelKey] = source[snakeKey];
    }
  }

  return atmosphereMemberProfileSchema.parse(normalized);
}
